<template>
  <div class="video">
    <div class="video__vimeo-player"></div>
  </div>
</template>

<script>
import Player from '@vimeo/player'

export default {
  name: 'Video',
  props: {
    content: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      windowWidth: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
      video: null,
      Player
    }
  },
  mounted() {
    this.setupVimeoPlayer()
  },
  methods: {
    setupVimeoPlayer() {
      const videoEl = document.querySelector('.video__vimeo-player')
      this.video = new Player(videoEl, {
        id: this.content,
        width: this.windowWidth < 1300 ? (this.windowWidth < 769 ?  this.windowWidth - 20 : this.windowWidth * 0.85) : 1200,
        autoplay: false,
        byline: false,
        title: false,
        portrait: false,
        playsinline: false
      })

      this.video.setColor('#fff')

      this.video.ready().then(function() {
          // the player is ready
          videoEl.classList.add('loaded')
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.video {
  max-width: 1130px;
  margin: auto;

  .video__vimeo-player {
    position: relative;
    padding-bottom: 56.25%;
    height: 0;
    overflow: hidden;
    width: 100%;

    &::after {
      content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='40' height='40'%3E%3Cpath opacity='.2' fill='%23fff' d='M20.201 5.169c-8.254 0-14.946 6.692-14.946 14.946 0 8.255 6.692 14.946 14.946 14.946s14.946-6.691 14.946-14.946c-.001-8.254-6.692-14.946-14.946-14.946zm0 26.58c-6.425 0-11.634-5.208-11.634-11.634 0-6.425 5.209-11.634 11.634-11.634 6.425 0 11.633 5.209 11.633 11.634 0 6.426-5.208 11.634-11.633 11.634z'/%3E%3Cpath fill='%23fff' d='M26.013 10.047l1.654-2.866a14.855 14.855 0 0 0-7.466-2.012v3.312c2.119 0 4.1.576 5.812 1.566z'%3E%3CanimateTransform attributeType='xml' attributeName='transform' type='rotate' from='0 20 20' to='360 20 20' dur='0.5s' repeatCount='indefinite'/%3E%3C/path%3E%3C/svg%3E");
      position: absolute;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 2;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: $color--base;
      opacity: 1;
      transition: opacity 0.25s cubic-bezier(0.445, 0.05, 0.55, 0.95), z-index 0.3s linear;
    }

    &.loaded {
      &::after {
        opacity: 0;
        pointer-events: none;
        z-index: -1;
      }
    }
  }

  @include mobile {
  }
}
</style>

<style lang="scss">
.video__vimeo-player {
    iframe,
    object,
    embed {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
}
</style>
